// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-strikethrough"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.76746 9.00283C6.59528 8.57076 6.49716 8.07372 6.49716 7.50072C6.49716 3.99636 9.99788 3.00195 12.0027 3.00195C14.1559 3.00195 15.7842 3.8578 17.504 4.99683M9.0044 12.002H11.9951L12.0069 12.0041C13.8458 12.3401 17.5 13.0079 17.5 16.5047C17.5 20.009 13.9993 21.0034 11.9945 21.0034C9.83955 21.0034 8.21487 20.1503 6.49967 19.0026M19 12.0007H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatStrikethroughIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-strikethrough',
    ref,
    icon: element,
  },
));

TextformatStrikethroughIcon.displayName = 'TextformatStrikethroughIcon';

export default TextformatStrikethroughIcon;
